import * as React from 'react';
import { useContext } from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import lightTheme from '../../../lib/themes/light';
import darkTheme from '../../../lib/themes/dark';
import { ThemeContext, ThemeProvider } from '../../../lib/contexts/ThemeContext';

export default function ProgressBar({ sections, onSectionClick }) {
  const {
    state: { finalTheme },
  } = useContext(ThemeContext);

  return (
    <ThemeProvider theme={finalTheme}>
      <Timeline style={{ marginLeft: '-100px' }}>
        {sections.map((section, index) => (
          <TimelineItem key={index}>
            <TimelineSeparator>
              <TimelineDot
                sx={{ backgroundColor: section.open ? finalTheme.palette.secondary.main : 'grey' }}
                onClick={() => onSectionClick(index)}
                style={{ cursor: 'pointer' }}
              />
              {index < sections.length - 1 && <TimelineConnector />}
            </TimelineSeparator>
            <TimelineContent sx={{ width: '40px', fontWeight: section.open ? 'bold' : 'normal' }}>
              {section.name}
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    </ThemeProvider>
  );
}
